import { render, staticRenderFns } from "./SystemUpdates.vue?vue&type=template&id=35c26c9c&scoped=true"
import script from "./SystemUpdates.vue?vue&type=script&lang=js"
export * from "./SystemUpdates.vue?vue&type=script&lang=js"
import style0 from "./SystemUpdates.vue?vue&type=style&index=0&id=35c26c9c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c26c9c",
  null
  
)

export default component.exports